import { makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles";
import { theme, service, system } from "src/styles/themes";

export const useServiceHeaderStyle = makeStyles((MuiTheme: Theme) => ({
  header: {
    width: "100%",
    height: 64,
    backgroundColor: theme.white,
    borderBottom: `1px solid ${service.gray_100}`,
    boxShadow: "0 1px 2px 0 rgba(33, 37, 41, 0.04)",
  },
  header_inner: {
    width: "100%",
    maxWidth: 1920 - 120,
    height: "100%",
    margin: "0 auto",
    padding: "0 40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  headerLeft: {},
  headerRight: {
    height: "100%",
    alignItems: "center",
  },
  logoButton: {
    width: 168,
    height: 24,
    padding: 0,
    transition: "opacity .2s",
    "& svg": {
      width: "100%",
      height: "100%",
    },
    "&:hover": {
      backgroundColor: "inherit",
      opacity: 0.78,
    },
  },
  menuItem: {
    marginLeft: 6,
    height: 36,
    padding: "6px 12px",
    whiteSpace: "nowrap",
    fontSize: `15px !important` as any,
    lineHeight: 1.5,
    letterSpacing: "-0.3px",
    borderRadius: 8,
    fontWeight: `${500} !important` as any,
    color: `${theme.gray_7_text} !important`,
    fill: "currentColor",
    transition: "color .18s",
    backgroundColor: "transparent !important",
    textDecoration: "none !important",

    "& *": {
      fontSize: `15px !important` as any,
    },

    "&:hover": {
      color: `${service.primary_600} !important`,
      textDecoration: "none !important",
    },
    "&.activation": {
      color: `${service.primary_700} !important`,
      fontWeight: `${600} !important` as any,
    },
  },

  menuOption: {
    position: "relative",
    display: "inline-block",

    "&:hover $menuOptionContent": {
      display: "block",
    },
  },

  menuOptionContent: {
    display: "none",
    width: 190,
    position: "absolute",
    marginLeft: 6,
    zIndex: 10,
    "&:hover": {
      cursor: "pointer",
    },
  },
  creditButton: {
    marginRight: 6,
    height: 40,
    padding: "12px 8px",
    whiteSpace: "nowrap",
    transition: "background .25s, color .25s, border .25s",
    border: "0",
    borderRadius: theme.round_3,
    fontSize: 16,
    lineHeight: 2,
    letterSpacing: "-0.48",
    ...theme.font_regular,
    color: theme.white,
    backgroundColor: service.cool_gray_500,
    fill: "currentColor",
    "@media (hover: hover)": {
      "&:hover": {
        backgroundColor: service.cool_gray_700,
      },
    },
    "&:active": {
      backgroundColor: service.cool_gray_900,
    },
    "&:disabled, &.Mui-disabled": {
      color: service.gray_500,
      backgroundColor: service.gray_200,
    },
  },
  paymentHistoryButton: {
    marginRight: 24,
    height: 40,
    padding: "12px 8px",
    whiteSpace: "nowrap",
    transition: "background .25s, color .25s, border .25s",
    border: "0",
    borderRadius: theme.round_3,
    fontSize: 16,
    lineHeight: 2,
    letterSpacing: "-0.48",
    ...theme.font_regular,
    color: theme.white,
    backgroundColor: service.cool_gray_500,
    fill: "currentColor",
    "@media (hover: hover)": {
      "&:hover": {
        backgroundColor: service.cool_gray_700,
      },
    },
    "&:active": {
      backgroundColor: service.cool_gray_900,
    },
    "&:disabled, &.Mui-disabled": {
      color: service.gray_500,
      backgroundColor: service.gray_200,
    },
  },
  logoutButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 36,
    height: 36,
    borderRadius: 8,
    border: `1px solid ${service.gray_200}`,
    backgroundColor: service.white,
    color: service.gray_600,
    marginLeft: 8,
    transition: "background-color .18s, border-color .18s, color .18s",
    "& svg": { width: 16, height: 16 },
    "&:hover": {
      backgroundColor: service.gray_50,
      borderColor: service.gray_300,
      color: service.gray_900,
    },
  },
  user_email: {
    gap: 6,
    padding: "5px 10px",
    borderRadius: 999,
    backgroundColor: service.gray_50,
    border: `1px solid ${service.gray_200}`,
    cursor: "pointer",
    transition: "background-color .18s, border-color .18s",
    "& p": {
      fontSize: 13,
      color: `${service.gray_700} !important`,
    },
    "& svg": {
      width: 14,
      height: 14,
      color: service.gray_400,
    },
    "&:hover": {
      backgroundColor: service.gray_100,
      borderColor: service.gray_200,
    },
  },
  account_arrow: {
    width: `18px !important` as any,
    height: `18px !important` as any,
    fontSize: `18px !important` as any,
    color: `${service.gray_700} !important`,
    transition: "transform .18s",
  },
  account_arrow_open: {
    transform: "rotate(180deg)",
  },
  account_popover: {
    "& .MuiPaper-rounded": {
      marginTop: 8,
      minWidth: 180,
      borderRadius: 12,
      boxShadow: "0 8px 24px 0 rgba(33, 37, 41, 0.10)",
      border: `1px solid ${service.gray_200}`,
      overflow: "hidden",
    },
  },
  account_popover_item: {
    width: "100%",
    padding: "10px 16px",
    justifyContent: "flex-start",
    gap: 8,
    "& p": { color: `${theme.danger} !important` },
    "& svg": { width: 16, height: 16, color: theme.danger },
    "&:hover": {
      backgroundColor: system.danger_50,
    },
  },

  header_menu_btn: {
    "&&": {
      color: theme.gray_7_text,
      minWidth: 0,
      padding: 0,
      marginRight: 24,
      display: "none",
      visibility: "hidden",

      [MuiTheme.breakpoints.down("md")]: {
        display: "flex",
        visibility: "visible",
      },
    },
  },
}));
